<template>
  <view-page
      :baseRoute='baseRoute'
      :entity='entity'
      :button-access="componentAccess"
      :model-entity="modelEntity"
      :page-title="setPageTitle"
  >
    <template v-slot="{ model }">
      <commercial-product-extra-info-form
          v-if="model.id"
          readonly v-model="model"
          card-title="Extra Info"
          :ProductCompanyType="ProductCompanyType"
          :ProductCompanyType_FK="ProductCompanyType_FK"
      />
    </template>

    <template v-slot:extra-button="{ model }">
      <vs-button
          v-if="model"
          class="mt-2 ml-4"
          color="light"
          @click="openEnableAlert(model)"
      >
        {{ model.IsEnabled ? "Deactivate" : "Activate" }}
      </vs-button>
    </template>
  </view-page>
</template>

<script>

import CommercialProductExtraInfoForm from "@/views/pages/commercial-products-ipr/CommercialProductExtraInfoForm";
import ViewPage from "@/views/components/Views/ViewPage";
import NotificationMixin from '../../../components/mixins/NotificationMixin';
import EnablePublishMixin from '../../../components/mixins/EnablePublishMixin';
import IprProductCompanyTypeMixin from "@/components/mixins/IprProductCompanyTypeMixin";


export default {
  name: "CommercialProductExtraInfo",
  components: {
    CommercialProductExtraInfoForm,
    ViewPage,
  },
  mixins: [NotificationMixin, EnablePublishMixin, IprProductCompanyTypeMixin],
  data() {
    return {
      baseRoute: `${this.ProductCompanyType}.commercial-products-ipr.extra-info`,
      entity:'Commercial Product',
      modelEntity: this.$api[this.companyTypeApiModel('commercialProductsIpr')],
      componentAccess: {
        canEdit: {
          route:  `${this.ProductCompanyType}.commercial-products-ipr.extra-info.edit`,
          access: false,
        },
        canDelete: {
          route:  `${this.ProductCompanyType}.commercial-products-ipr.delete`,
          access: false,
        },
        canRestore: {
          route:  `${this.ProductCompanyType}.commercial-products-ipr.restore`,
          access: false,
        },
      }
    };
  },
  methods: {
    setPageTitle(params) {
      if (!params.CommercialProductName) {
        return '';
      }
      const name = params.CommercialProductName || '';
      return "Commercial Product: " + name;
    }
  }
};
</script>

<style scoped>

</style>
